import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './House.scss';

const House = (props) => (
    <Icon iconName="House" {...props}>
        <svg viewBox="0 0 43 43" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-735.000000, -850.000000)" stroke="#FFFFFF" strokeWidth="1.5">
                    <g transform="translate(735.000000, 850.000000)">
                        <path
                            // eslint-disable-next-line
                            d="M41.8837,21.3173 C41.8837,32.6753 32.6757,41.8833 21.3167,41.8833 C9.9577,41.8833 0.7497,32.6753 0.7497,21.3173 C0.7497,9.9583 9.9577,0.7503 21.3167,0.7503 C32.6757,0.7503 41.8837,9.9583 41.8837,21.3173 Z"
                            fillOpacity="0.4"
                            fill="#020A0D"
                        />
                        <path d="M9.8803,21.0761 L20.2513,12.2921 C20.8813,11.7291 21.7523,11.7291 22.3823,12.2921 L32.7543,21.0761" strokeLinecap="round" />
                        <path
                            // eslint-disable-next-line
                            d="M29.3286,18.1053 L29.3286,27.7393 C29.3286,28.8693 28.5506,29.7843 27.5906,29.7843 L15.1016,29.7843 C14.1416,29.7843 13.3636,28.8693 13.3636,27.7393 L13.3636,18.1053"
                            strokeLinecap="round"
                        />
                        <path
                            // eslint-disable-next-line
                            d="M23.3168,29.7362 L19.8058,29.7362 C19.3548,29.7362 18.9898,29.3712 18.9898,28.9212 L18.9898,22.9662 C18.9898,22.5162 19.3548,22.1512 19.8058,22.1512 L23.3168,22.1512 C23.7678,22.1512 24.1328,22.5162 24.1328,22.9662 L24.1328,28.9212 C24.1328,29.3712 23.7678,29.7362 23.3168,29.7362 Z"
                            strokeLinecap="round"
                        />
                    </g>
                </g>
            </g>
        </svg>
    </Icon>
);

export default House;
